var React = require('react');

function IconLetter (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon-letter","fill":"currentColor","fillRule":"evenodd"},[React.createElement("path",{"d":"M2,6 C2,5.44771525 2.44771525,5 3,5 L21,5 C21.5522847,5 22,5.44771525 22,6 L22,18 C22,18.5522847 21.5522847,19 21,19 L3,19 C2.44771525,19 2,18.5522847 2,18 L2,6 Z M4,7 L4,17 L20,17 L20,7 L4,7 Z","id":"Rectangle","key":0}),React.createElement("path",{"d":"M12,11.7331384 L3.61394061,5.21064778 L2.38605939,6.78935222 L11.3860594,13.7893522 C11.7471699,14.0702159 12.2528301,14.0702159 12.6139406,13.7893522 L21.6139406,6.78935222 L20.3860594,5.21064778 L12,11.7331384 Z","id":"Path","key":1})]));
}

IconLetter.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = IconLetter;

IconLetter.default = IconLetter;
